import {
  cn,
  Avatar as AvatarBase,
  AvatarImage,
  AvatarFallback,
} from "web-design-system";
import { cva, VariantProps } from "class-variance-authority";

const variants = cva("rounded-lg", {
  variants: {
    size: {
      default: "w-9 h-9",
      sm: "w-8 h-8",
      lg: "w-12 h-12",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export function AvatarEmployee({
  url,
  fallback,
  size,
  className,
}: {
  url?: string;
  fallback: string;
  size?: VariantProps<typeof variants>["size"];
  className?: string;
}) {
  return (
    <AvatarBase
      className={cn(
        variants({ size }),
        className,
        "bg-slate-400 text-white dark:bg-slate-700 dark:text-slate-50 rounded-full"
      )}
    >
      <AvatarImage
        className={cn(variants({ size }), "object-contain")}
        src={url}
      />
      <AvatarFallback className="bg-transparent text-sm">
        {fallback}
      </AvatarFallback>
    </AvatarBase>
  );
}
